export const AppConstants = {
    AIR_TAXI: "airTaxi",
    CARGO: "cargo",
    PILOT_TRAINING: "pilotTraining",
    EXPERIENCE: "experience",
    ONE_WAY: "one-way-trip",
    ROUND_TRIP: "round-trip",
    SCROLL_POSITION: "50",
    PHONE_REGULAR_EXP: /^(\d{10}|(\+?\d{1,3}[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4})$/,
    NAME_REG_EXP: /^[a-zA-Z]+$/,
    EMAIL_REG_EXP: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
};